export default "__VITE_ASSET__B1dlYGKN__"